// extracted by mini-css-extract-plugin
export default {"selectWrapper":"dxW5iNfX","select":"kX929wE7"};